export default "/images/columns.svg?21328f896ab2b21f96533339b4122e27";